<template>
  <div id="promotion">
    <div class="content_box">
      <div class="inner">
        <div class="contact_title">
          <h2>{{ title }}</h2>
          <p></p>
        </div>
        <div class="description_title mb-5 px-24 text-center">
          <p class="px-10 leading-relaxed vhtml_component" v-html="description1"></p>
        </div>

        <OptInOut
          :description="description2"
          :description2="description3"
          :optIn="optIn"
          @successfulCallback="successfulCallback"
          :tncLink="tncLink"
          :autoOptIn="autoOptIn"
        ></OptInOut>

        <div class="tab_title py-7.5">
          <Accordion :list="list" :title="tabName" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OptInOut from '@/components/promotion/OptInOut';
import Accordion from '@/components/promotion/Accordion';
import { apiCampaignInfo } from '@/resource';
import router from '@/router';

export default {
  name: 'promotion',
  components: { OptInOut, Accordion },
  data() {
    return {
      description1: null,
      description2: null,
      description3: null,
      optIn: false,
      autoOptIn: 1,
      tncLink: null,
      title: null,
      tabName: null,
      list: []
    };
  },
  watch: {
    langUsed() {
      this.getPromotionInfo();
    },
    '$route.params.campaignId': function () {
      this.getPromotionInfo();
    }
  },
  computed: {
    campaignID() {
      let campaign = this.$store.state.promotion.eligibleCampaigns.find(c => c.campaignType === campaignType);
      return campaign ? campaign.id : null;
    },
    langUsed() {
      return this.$store.state.common.lang;
    },
    campaignType() {
      const campaignType = this.$route.params['campaignName'];
      return campaignType.replace(/([a-z])([A-Z])/g, '$1_$2').toUpperCase();
    },
    validateCampaignId() {
      return this.$route.params['campaignId'];
    },
  },
  methods: {
    getPromotionInfo() {
      apiCampaignInfo(this.validateCampaignId, this.langUsed)
        .then(resp => {
          if (resp.data.code === 0) {
            this.title = resp.data.data.clientPortalSettings.pageTitle;
            this.description1 = resp.data.data.clientPortalSettings.description1;
            this.description2 = resp.data.data.clientPortalSettings.description2;
            this.description3 = resp.data.data.clientPortalSettings.description3;
            this.optIn = resp.data.data.optIn;
            this.tncLink = resp.data.data.clientPortalSettings.tncLink;
            this.tabName = resp.data.data.clientPortalSettings.tabName;
            this.list = resp.data.data.clientPortalSettings.tabNameList;
            this.autoOptIn = resp.data.data.autoOptIn ? resp.data.data.autoOptIn : 1;
          } else {
            router.push('/');
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    successfulCallback(optIn) {
      this.$message({
        message: optIn ? this.$t('promotion.depositBonus.optIn') : this.$t('promotion.depositBonus.optOut'),
        type: 'success',
        duration: 5000
      });
      this.getDespositBonusInfo();
    }
  },
  mounted() {
    this.getPromotionInfo();
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/promotion.scss';
@import '@/assets/css/components/promotion/clientPortalSettings.scss';
</style>
